import { graphHooks } from '@tunasong/graph-lib/react'
import type { FeedItem } from '@tunasong/models'
import { useCurrentUser } from '@tunasong/redux'
import { UserAvatar, getProfileColor, Avatar} from '@tunasong/ui-lib'
import type { FC, Ref } from 'react'
import ChatItem from './chat-item.js'
import styles from './chat-feed-item.module.css'

export interface ChatFeedItemProps {
  item: FeedItem
  highlight?: boolean
  ref: Ref<HTMLDivElement>
}

const userAvatarWithUser = (userId: string) => () => <UserAvatar className={styles.avatar} userId={userId} size="small" />
const DummyAvatar = () => <Avatar className={styles.avatar} />

export const ChatFeedItem: FC<ChatFeedItemProps> = props => {
  const { item, highlight = false, ref, ...restProps } = props
  const itemUserId = item.userId
  const { userId: currentUserId } = useCurrentUser()

  const { profile } = graphHooks.useProfile(item.userId)

  const UserIcon = itemUserId ? userAvatarWithUser(itemUserId) : DummyAvatar
  const type = currentUserId === item.userId ? 'message' : item.userId === 'assistant' ? 'assistant' : 'response'
  const { colorName } = getProfileColor(profile)

  return (
    <ChatItem
      key={item.id}
      {...restProps}
      ref={ref}
      highlight={highlight}
      type={type}
      color={colorName}
      name={profile?.name ?? 'Unknown'}
      actions={item.actions}
      UserIcon={UserIcon}
      timestamp={item.createdAt}
    >
      {item.content}
    </ChatItem>
  )
}

export default ChatFeedItem
